import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { BillingResponse } from '../models/billing-response.model';
import { BillingRepository } from '../repositories/billing.repository';

export class SendUserDataUseCase implements UseCase<void, BillingResponse> {
    constructor(private readonly repository: BillingRepository) {}

    execute(): Observable<BillingResponse> {
        return this.repository.sendUserData();
    }
}
